import Users from "../Users/Users";

const Home = () => {
  return <Users />;
};
export default Home;
